import {PAGES} from "../../../../../core/consts";
import {BaseLinkModel} from "../../../../../infrastructure/models/link/base-link-model";
import {CompetitionLinkParams} from "../../../models/competition-link-params";

export class CompetitionOddsPageLinkModel extends BaseLinkModel  {
  constructor(competitionId, sportName, competitionName, isFollow: Boolean = true) {
    super(PAGES.COMPETITION.odds, new CompetitionLinkParams(competitionId, sportName, competitionName), false, null, null);

    this.isFollow = isFollow;
  }
}